import { RootState } from "store/reducers/main";
import { ChannelFeaturesEnum } from "types/working-model";

export const selectChannelFeatures = (state: RootState) => {
	const channel = selectCurrentChannel(state);
	return channel?.enabled_features ?? [];
};

export const canUseChannelFeature = (feature: ChannelFeaturesEnum) => (state: RootState) => {
	const features = selectChannelFeatures(state);
	return !!features?.includes(feature);
};

export const selectCurrentChannel = (state: RootState) => {
	const user = state.AuthReducer.user;
	return state.AuthReducer.channels?.find((c) => c.channel === user?.active_channel);
};